<script lang="ts">
import { defineComponent } from 'vue'
import ButtonSns from '@/components/button/ButtonSns.vue'
import {
  userFacebookOmniauthAuthorizePath,
  userGoogleOauth2OmniauthAuthorizePath,
} from '@/generated/railsRoutes'
import { useMediaQueryStore } from '@/stores/mediaQuery'

export default defineComponent({
  name: 'OAuthOptions',

  components: {
    ButtonSns,
  },

  props: {
    /**
     * ログイン用かどうか
     *
     * true : 見出し部分の表記が「ログイン」
     * false: 見出し部分の表記が「登録」
     */
    isSignIn: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    // store
    const mediaQueryStore = useMediaQueryStore()

    return {
      // routes
      userFacebookOmniauthAuthorizePath,
      userGoogleOauth2OmniauthAuthorizePath,

      // store
      mediaQueryStore,
    }
  },
})
</script>

<template>
  <div class="l-unit__oAuthOption">
    <div class="l-unit__oAuthOption--description">
      <div class="o-label__methodSeparator">
        <p class="o-label__methodSeparator--item">
          または
        </p>
      <!-- /.o-label__methodSeparator --></div>

      <div class="o-list__oAuthOption">
        <dl class="o-list__oAuthOption--unit">
          <dt class="o-list__oAuthOption--term">
            他サービス ID で{{ isSignIn ? 'ログイン' : '登録' }}
          </dt>

          <dd class="o-list__oAuthOption--description is-facebook">
            <ButtonSns
              :href="userFacebookOmniauthAuthorizePath()"
              :filled="false"
              service="facebook">
              {{ mediaQueryStore.context.isUnderPhablet ? '' : 'Facebook' }}
            </ButtonSns>
          </dd>
          <dd class="o-list__oAuthOption--description is-google">
            <ButtonSns
              :href="userGoogleOauth2OmniauthAuthorizePath()"
              :filled="false"
              service="google">
              {{ mediaQueryStore.context.isUnderPhablet ? '' : 'Google' }}
            </ButtonSns>
          </dd>
        </dl>
      <!-- /.o-list__oAuthOption --></div>

      <div class="o-note">
        <p class="o-note--item u-text__x-small u-text__center">
          BizHintがあなたの許可無く投稿することはありません。
        </p>
      <!-- /.o-note --></div>
    <!-- /.l-unit__oAuthOption description --></div>
  <!-- /.l-unit__oAuthOption --></div>
</template>

<style lang="sass" scoped>
// layout
.l-unit__oAuthOption
  margin-top: 1.5em

  &:first-child
    margin-top: 0

// object
.o-label__methodSeparator
  display: flex
  align-items: center
  margin: 1em 0

  &:first-child
    margin-top: 0

  &::before,
  &::after
    content: ""
    height: 1px
    display: block
    flex-grow: 1
    background-color: rgba($border-x-light-gray, 1)

  & &--item
    font-size: $font-x-small
    padding: 0 0.5em

.o-list__oAuthOption
  $root: &
  margin-top: 1em

  &:first-child
    margin-top: 0

  & &--unit
    $submit-button-size: 384
    $button-cols: 2
    $button-width-percent: math.div(100%, $button-cols)
    $button-width-px-max: math.div($submit-button-size, $button-cols)
    min-width: 0
    display: grid
    grid-template-columns: 1fr minmax(auto, #{$button-width-px-max}px) minmax(auto, #{$button-width-px-max}px) 1fr
    justify-content: center
    justify-items: center
    align-items: center
    column-gap: 0.5em
    font-size: $font-small

  & &--term
    $font-size-px: 12
    grid-column: 1 / 5
    grid-row: 1 / 2
    font:
      size: changeSizePx2Em($font-size-px, $font-small-px)
      weight: bold
    text-align: center
    margin-bottom: changeSizePx2Em(14, $font-x-small-px)

  & &--description
    width: 100%
    grid-row: 2 / 3

    &:first-child
      margin-left: 0

    &.is-facebook
      grid-column: 2 / 3

    &.is-google
      grid-column: 3 / 4
</style>
